/* eslint-disable react/require-default-props */
import React from 'react';
import classNames from 'classnames';
import { Text } from '../../atoms/Text/Text';
import './AILoadingPlaceholderStyles.scss';
const baseClass = 'qmb-ui-ai-loading-placeholder';
/**
 * AILoadingPlaceholder Organism
 * Loading indicator with a spinning icon and a branded label.
 * Used as the Suspense fallback for lazy-loaded blocks and for general "thinking" states.
 * @version 1.0.0
 * @since 2026-02-18
 */
export function AILoadingPlaceholder({ label, detail, className }) {
    const ariaLabel = detail ? `${label} ${detail}` : label;
    return (React.createElement("div", { className: classNames(baseClass, className), role: "status", "aria-label": ariaLabel },
        React.createElement("i", { className: classNames('fa-light fa-loader', `${baseClass}__icon`), "aria-hidden": "true" }),
        React.createElement("div", { className: `${baseClass}__text` },
            React.createElement(Text, { key: label, variant: "xx-small", className: `${baseClass}__label` }, label),
            detail && (React.createElement(Text, { key: detail, variant: "xx-small", className: `${baseClass}__detail` }, detail)))));
}
